module.exports = __webpack_public_path__ + "static/pic1-5f73e36ce509262a97666954909afaf6.jpg";